(() => {
  const offers = {
    '47845626839094': 'ZV-CART-COPYCAT-1999',
    '47845816401974': 'ZV-CART-LOWCARB-1999',
    '47616637534262': 'ZV-CART-PANTRY-1999',
    '47845829771318': 'ZV-CART-PROTEIN-1999'
  };
  const selector = '[id$="cart_product_upsells_ddT8Wb"] button[id^="DisplayedSubmitBtn-"]';
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let cleanupTimer;
  async function request(path, body) {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    } : {});
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }
  function codesFor(cart, variant) {
    const present = new Set(cart.items.map(item => String(item.variant_id)));
    if (variant) present.add(variant);
    const known = new Map(Object.entries(offers).map(([id, code]) => [code, id]));
    const codes = (cart.discount_codes || []).map(item => item.code).filter(code =>
      !known.has(code.toUpperCase()) || present.has(known.get(code.toUpperCase()))
    );
    if (variant && !codes.some(code => code.toUpperCase() === offers[variant])) codes.push(offers[variant]);
    return codes;
  }
  async function cleanup() {
    if (busy) return;
    try {
      const cart = await request('cart.js');
      if (busy) return;
      const codes = codesFor(cart);
      if (codes.length !== (cart.discount_codes || []).length) {
        await request('cart/update.js', { discount: codes.join(',') });
      }
    } catch {}
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest?.(selector);
    if (!button) return;
    const upsell = button.closest('cart-drawer-upsell');
    const variant = upsell?.querySelector('input[name="id"]')?.value;
    if (!offers[variant]) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || button.disabled) return;
    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const cart = await request('cart.js');
      await request('cart/update.js', { discount: codesFor(cart, variant).join(',') });
      const form = upsell.querySelector('form');
      const data = new FormData(form);
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer.getSectionsToRender().map(section => section.id);
      data.set('sections', sections.join(','));
      data.set('sections_url', window.location.pathname);
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data });
      const added = await response.json();
      if (!response.ok || added.status) throw new Error('Unable to add item');
      drawer.renderContents(added);
    } catch {
      const error = document.createElement('p');
      error.setAttribute('role', 'alert');
      error.textContent = window.cartStrings?.error || 'Please refresh the cart and try again.';
      upsell.append(error);
      button.disabled = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      busy = false;
    }
  }, true);
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(records => {
    const changed = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches('#CartDrawer-CartItems') || node.querySelector('#CartDrawer-CartItems'))
    ));
    if (!changed) return;
    clearTimeout(cleanupTimer);
    cleanupTimer = setTimeout(cleanup, 800);
  }).observe(drawer, { childList: true, subtree: true });
  cleanup();
})();